import PostRepository from './PostRepository';
import UserRepository from './UserRepository';
import AuthorizationRepository from './AuthorizationRepository';
import PrintShotAppointmentsRepository from './PrintShotAppointmentsRepository';
import AppointmentsRepository from './AppointmentsRepository';
import BroadcastRepository from './BroadcastRepository';
import PatientRepository from './PatientRepository';
import FamilyAccountRepository from './FamilyAccountRepository';
const repositories = {
    'posts': PostRepository,
    'users': UserRepository,
    'authorization': AuthorizationRepository,
    'printshotappointments' : PrintShotAppointmentsRepository,
    'appointments' : AppointmentsRepository,
    'broadcast' : BroadcastRepository,
    'patients' : PatientRepository,               
    'familyaccount' : FamilyAccountRepository,                   
}
export default {
    get: name => repositories[name]
};